import React from 'react';
import { RENT_EXTRA_COST_COLORS } from '../../config/constants';
import { getRentMonthlyCostItems } from '../../utils/submissions';
import CostDonutChart from './CostDonutChart';

export const buildRentDonutSegments = (property) => {
  const items = getRentMonthlyCostItems(property);
  const base = Number(property?.monthlyRent) || 0;
  const segments = [];
  if (base > 0) {
    segments.push({ value: base, color: "var(--primary)", label: "Base rent", swatchClass: "rent-cost-donut-swatch--rent" });
  }
  items.forEach((row, i) => {
    const amt = Number(row.amount) || 0;
    if (amt > 0) {
      segments.push({
        value: amt,
        color: RENT_EXTRA_COST_COLORS[i % RENT_EXTRA_COST_COLORS.length],
        label: row.label,
      });
    }
  });
  return segments;
};

const RentCostDonutChart = ({ property, total, country, compact = false }) => (
  <CostDonutChart
    segments={buildRentDonutSegments(property)}
    total={total}
    country={country}
    compact={compact}
    centerHint="Monthly"
    ariaLabel="Monthly rent and additional costs"
  />
);

export default RentCostDonutChart;
